/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Ai controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TranscribeAudioResponse, StartAiConversationResponse, SendAiMessageRequest, SendAiMessageResponse, ResolveAiNameRequest, GetCustomerAnalysisResponse, ConfirmAiActionResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AiService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    transcribeAudio(file: Blob, observe?: 'body', options?: RequestOptions<'json'>): Observable<TranscribeAudioResponse>;
    transcribeAudio(file: Blob, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TranscribeAudioResponse>>;
    transcribeAudio(file: Blob, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TranscribeAudioResponse>>;
    transcribeAudio(file: Blob, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Transcriptions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (file !== undefined) {
            formData.append('file', file);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    startAiConversation(observe?: 'body', options?: RequestOptions<'json'>): Observable<StartAiConversationResponse>;
    startAiConversation(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<StartAiConversationResponse>>;
    startAiConversation(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<StartAiConversationResponse>>;
    startAiConversation(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Conversations`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, null, requestOptions);
    }

    sendAiMessage(conversationId: number, sendAiMessageRequest: SendAiMessageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<SendAiMessageResponse>;
    sendAiMessage(conversationId: number, sendAiMessageRequest: SendAiMessageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<SendAiMessageResponse>>;
    sendAiMessage(conversationId: number, sendAiMessageRequest: SendAiMessageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<SendAiMessageResponse>>;
    sendAiMessage(conversationId: number, sendAiMessageRequest: SendAiMessageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Conversations/${conversationId}/Messages`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, sendAiMessageRequest, requestOptions);
    }

    resolveAiName(conversationId: number, resolveAiNameRequest: ResolveAiNameRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    resolveAiName(conversationId: number, resolveAiNameRequest: ResolveAiNameRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    resolveAiName(conversationId: number, resolveAiNameRequest: ResolveAiNameRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    resolveAiName(conversationId: number, resolveAiNameRequest: ResolveAiNameRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Conversations/${conversationId}/Resolve`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, resolveAiNameRequest, requestOptions);
    }

    deleteAiConversation(conversationId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteAiConversation(conversationId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteAiConversation(conversationId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteAiConversation(conversationId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Conversations/${conversationId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getCustomerAnalysis(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerAnalysisResponse>;
    getCustomerAnalysis(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerAnalysisResponse>>;
    getCustomerAnalysis(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerAnalysisResponse>>;
    getCustomerAnalysis(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Customer/${customerId}/Analysis`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    confirmAiAction(messageId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<ConfirmAiActionResponse>;
    confirmAiAction(messageId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<ConfirmAiActionResponse>>;
    confirmAiAction(messageId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<ConfirmAiActionResponse>>;
    confirmAiAction(messageId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Actions/${messageId}/Confirm`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, null, requestOptions);
    }

    cancelAiAction(messageId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    cancelAiAction(messageId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    cancelAiAction(messageId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    cancelAiAction(messageId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Ai/Actions/${messageId}/Cancel`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, null, requestOptions);
    }
}
